import { render, staticRenderFns } from "./RevenuesTypeChangeActivationType.vue?vue&type=template&id=5519a4a5&"
import script from "./RevenuesTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports